import { Animation, Colors, Shadows, } from '../../../theme';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
const Styles = labelStyles('Surface', {
    root: (backgroundColor, shadow, borderColor) => [
        {
            borderRadius: 5,
            transitionProperty: 'box-shadow, border-color, background-color',
            transitionTimingFunction: Animation.transitionTimingFunction,
            transitionDuration: Animation.transitionDuration,
            alignItems: 'stretch',
            flex: 1,
            maxWidth: '100%',
        },
        backgroundColor &&
            withModifier(backgroundColor, {
                backgroundColor: Colors[backgroundColor],
            }),
        borderColor &&
            withModifier(`border-${borderColor}`, {
                border: `1px solid ${Colors[borderColor]}`,
            }),
        shadow &&
            withModifier('hasShadow', {
                boxShadow: Shadows[shadow],
            }),
    ],
});
export const Surface = (props) => {
    const { backgroundColor = 'transparent', shadow, borderColor } = props;
    return (isolateComponent("div", { css: Styles.root(backgroundColor, shadow, borderColor) }, props.children));
};
//# sourceMappingURL=Surface.js.map
// @zapier/design-system@5.32.5 (2004a9d50)
